/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Verify_DescInputs */

const en_pc_dl_verify_desc = /** @type {(inputs: Pc_Dl_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare the output of this command with the matching line in SHA256SUMS.txt.`)
};

const zh_pc_dl_verify_desc = /** @type {(inputs: Pc_Dl_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将此命令的输出与 SHA256SUMS.txt 中对应的一行进行比较。`)
};

/**
* | output |
* | --- |
* | "Compare the output of this command with the matching line in SHA256SUMS.txt." |
*
* @param {Pc_Dl_Verify_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_verify_desc = /** @type {((inputs?: Pc_Dl_Verify_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Verify_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_verify_desc(inputs)
	return zh_pc_dl_verify_desc(inputs)
});
export { pc_dl_verify_desc as "pc.dl.verify_desc" }